// extracted by mini-css-extract-plugin
export default {"reminder":"reminder-d3ST"};